<template>
  <el-dialog
    :visible.sync="isShow"
    width="800px"
    class="linkAllDialog"
    :title="title"
    :close-on-click-modal="false"
    top="12vh">
    <!--  -->
    <el-select
      v-if="type === 'player' || type === 'event'"
      v-model="squadUuid"
      style="margin-bottom:20px;"
      clearable
      @change="changeQuery(true)"
      >
      <!-- @change="getPlayerList" -->
      <el-option label="全部球队" value=""></el-option>
      <el-option
        v-for="(item, index) in squardList"
        :key="index"
        :label="item.shortName"
        :value="item.uuid"></el-option>
    </el-select>
    <div class="sss" style="height: 530px;padding-bottom: 10px">
      <template v-if="type==='player'">
        <yioks-loading v-if="loading" />
        <template v-else>
          <yioks-empty v-if="empty" :whiteBg="true" style="height:460px;"></yioks-empty>
          <div v-else class="associatContetn"  style="height: 460px">
            <div class="th" style="margin-right: 20px">
              <div class="tr img" style="border-left: 1px solid gray">
                <p>头像</p>
              </div>
              <div class="tr name">
                <p>姓名</p>
              </div>
              <div class="tr organName">
                <p>所属球队</p>
              </div>
              <!--<div class="tr youthName">-->
                <!--<p>当前培训机构</p>-->
              <!--</div>-->
              <!--<div class="tr idNumber">-->
                <!--<p>身份证号</p>-->
              <!--</div>-->
              <div class="tr choose" >
                <p>
                  全选
                  <el-checkbox v-model="checkedAll"  @change="changeAllBox"></el-checkbox>
                </p>
              </div>
            </div>
            <div style="height: 420px" class="scollContent">
              <vue-scroll :ops="ops">
                <div class="list" style="margin-right: 20px">
                  <div v-for="(item,index) in linkList" :key="item.id" class="tbody">
                    <div class="td img" style="border-left: 1px solid gray">
                      <img
                        :src="item.headImgUrl ? item.headImgUrl : person"
                        alt=""
                        style="width:45px;height:45px;border-radius:50%;"
                        @error="item.headImgUrl = person">
                    </div>
                    <div class="td name">
                      <p>{{item.idName}}</p>
                    </div>
                    <div class="td organName">
                      <p :title="item.workName">{{item.workName}}</p>
                    </div>
                    <!--<div class="td youthName">-->
                      <!--<p>{{item.youthShortName}}</p>-->
                    <!--</div>-->
                    <!--<div class="td idNumber">-->
                      <!--<p>{{item.idNumber}}</p>-->
                    <!--</div>-->
                    <div class="td choose" >
                      <el-checkbox v-model="item.checked" fill="#4cd964" @change="changeBox(item.checked,index)"></el-checkbox>
<!--                      <el-button v-if="item.checked" type="danger" size="small"  style="background-color: #f56c6c" icon="el-icon-remove-outline" @click="remove(index)">取消</el-button>-->
<!--                      <el-button v-else type="primary" size="small"  icon="el-icon-circle-plus-outline" @click="add(index)">关联</el-button>-->
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>
          <div>
            <page-small :pageSize="pageSize" :page.sync="page" :total="total"></page-small>
          </div>
          <template v-if="Object.keys(linkObj).length > 0">
            <div style="display: flex;justify-content: center;align-items: center;">
              <p>已选择{{Object.keys(linkObj).length}}人</p>
              <el-button
                type="primary"
                size="mini"
                style="margin-left: 15px"
                @click="isShow=false">关闭</el-button>
            </div>
          </template>
        </template>
      </template>
      <template v-if="type==='event'">
        <yioks-loading v-if="loading" />
        <template v-else>
          <yioks-empty v-if="empty" :whiteBg="true" style="height:460px;"></yioks-empty>
          <div v-else class="associatContetn"  style="height: 460px">
            <div class="th" style="margin-right: 20px">
              <div class="tr name" style="border-left: 1px solid gray">
                <p>训练计划</p>
              </div>
              <div class="tr organName">
                <p>球队名字</p>
              </div>
              <div class="tr youthName">
                <p>主教练</p>
              </div>
              <div class="tr idNumber">
                <p>开始时间</p>
              </div>
              <div class="tr choose" >
                <p>操作</p>
              </div>
            </div>
            <div style="height: 420px" class="scollContent">
              <vue-scroll :ops="ops">
                <div class="list" style="margin-right: 20px">
                  <div v-for="(item,index) in linkList" :key="item.id" class="tbody">
                    <div class="td name" style="border-left: 1px solid gray">
                      <p>{{item.trainingName}}</p>
                    </div>
                    <div class="td organName">
                      <p>{{item.squadName}}</p>
                    </div>
                    <div class="td youthName">
                      <p>{{item.chiefCoachName}}</p>
                    </div>
                    <div class="td idNumber">
                      <p>{{item.trainingTime | time}}</p>
                    </div>
                    <div class="td choose" >
                      <el-button
                        v-if="item.checked"
                        type="danger"
                        size="small"
                        style="background-color: #f56c6c"
                        icon="el-icon-remove-outline"
                        @click="remove(index)">取消</el-button>
                      <el-button
                        v-else
                        type="primary"
                        size="small"
                        icon="el-icon-circle-plus-outline"
                        @click="add(index)">关联</el-button>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>
          <div>
            <page-small :pageSize="pageSize" :page.sync="page" :total="total"></page-small>
          </div>
          <template v-if="Object.keys(linkObj).length > 0">
            <div style="display: flex;justify-content: center;align-items: center">
              <p>已选择{{Object.keys(linkObj).length}}个</p>
              <el-button
                type="primary"
                size="mini"
                style="margin-left: 15px"
                @click="isShow=false">关闭</el-button>
            </div>
          </template>
        </template>
      </template>
      <template v-if="type==='matchReport'">
        <yioks-loading v-if="loading" />
        <template v-else>
          <yioks-empty v-if="empty" :whiteBg="true" style="height:460px;"></yioks-empty>
          <div v-else class="associatContetn"  style="height: 460px">
            <div class="th" style="margin-right: 20px">
              <div class="tr name" style="border-left: 1px solid gray">
                <p>比赛报告</p>
              </div>
              <div class="tr organName">
                <p>球队名字</p>
              </div>
              <div class="tr youthName">
                <p>主教练</p>
              </div>
              <div class="tr idNumber">
                <p>开始时间</p>
              </div>
              <div class="tr choose" >
                <p>操作</p>
              </div>
            </div>
            <div style="height: 420px" class="scollContent">
              <vue-scroll :ops="ops">
                <div class="list" style="margin-right: 20px">
                  <div v-for="(item,index) in linkList" :key="item.id" class="tbody">
                    <div class="td name" style="border-left: 1px solid gray">
                      <p>{{item.trainingName}}</p>
                    </div>
                    <div class="td organName">
                      <p>{{item.squadName}}</p>
                    </div>
                    <div class="td youthName">
                      <p>{{item.chiefCoachName}}</p>
                    </div>
                    <div class="td idNumber">
                      <p>{{item.trainingTime | time}}</p>
                    </div>
                    <div class="td choose" >
                      <el-button
                        v-if="item.checked"
                        type="danger"
                        size="small"
                        style="background-color: #f56c6c"
                        icon="el-icon-remove-outline"
                        @click="remove(index)">取消</el-button>
                      <el-button
                        v-else
                        type="primary"
                        size="small"
                        icon="el-icon-circle-plus-outline"
                        @click="add(index)">关联</el-button>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>
          <div>
            <page-small :pageSize="pageSize" :page.sync="page" :total="total"></page-small>
          </div>
          <template v-if="Object.keys(linkObj).length > 0">
            <div style="display: flex;justify-content: center;align-items: center">
              <p>已选择{{Object.keys(linkObj).length}}个</p>
              <el-button
                type="primary"
                size="mini"
                style="margin-left: 15px"
                @click="isShow=false">关闭</el-button>
            </div>
          </template>
        </template>
      </template>
      <template v-if="type==='plan'">
        <yioks-loading v-if="loading" />
        <template v-else>
          <yioks-empty v-if="empty" :whiteBg="true" style="height:460px;"></yioks-empty>
          <div v-else class="associatContetn tutorial" style="height: 460px">
            <div style="height: 420px" class="scollContent">
              <vue-scroll :ops="ops">
                <div class="list" style="margin-right: 20px">
                  <div v-for="(item,index) in linkList" :key="item.id" class="item" >
                    <div class="title">{{item.title}}</div>
                    <div class="info_content">
                      <img :src="item.coverImgUrl" alt="" @error="item.coverImgUrl = placeHolderImg">
                      <div class="info">
                        <p>作者：{{item.authorName}}</p>
                        <p>分类：{{item.categoryZh}}</p>
                        <p>语言：{{item.language === 'zh' ? '中文' : '英文'}}</p>
                        <p>技术等级：{{item.skillLevelZh}}</p>
                      </div>
                      <div class="btn_wrap">
                        <p>最后更新时间：{{item.updatedAt | time}}</p>
                        <div class="btn">
                          <el-button
                            v-if="item.checked"
                            type="danger"
                            style="background-color: #f56c6c"
                            icon="el-icon-remove-outline"
                            @click="remove(index)">取消</el-button>
                          <el-button
                            v-else
                            type="primary"
                            icon="el-icon-circle-plus-outline"
                            @click="add(index)">关联</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>
          <div>
            <page-small :pageSize="pageSize" :page.sync="page" :total="total"></page-small>
          </div>
          <template v-if="Object.keys(linkObj).length > 0">
            <div style="display: flex;justify-content: center;align-items: center">
              <p>已选择{{Object.keys(linkObj).length}}个</p>
              <el-button
                type="primary"
                size="mini"
                style="margin-left: 15px"
                @click="isShow=false">关闭</el-button>
            </div>
          </template>
        </template>
      </template>
      <template v-if="type==='scout'">
        <yioks-loading v-if="loading" />
        <template v-else>
          <yioks-empty v-if="empty" :whiteBg="true" style="height:460px;"></yioks-empty>
          <div v-else class="associatContetn"  style="height: 460px">
            <div class="th" style="margin-right: 20px">
              <div class="tr danwei" style="border-left: 1px solid gray">
                <p>所属单位</p>
              </div>
              <div class="tr changci">
                <p>比赛名称与场次</p>
              </div>
              <div class="tr playerName">
                <p>球员姓名</p>
              </div>
              <div class="tr leixing">
                <p>报告类型</p>
              </div>
              <div class="tr choose" >
                <p>操作</p>
              </div>
            </div>
            <div style="height: 420px" class="scollContent">
              <vue-scroll :ops="ops">
                <div class="list" style="margin-right: 20px">
                  <div v-for="(item,index) in linkList" :key="item.id" class="tbody1">
                    <div class="td danwei" style="border-left: 1px solid gray" :title="item.organShortName + item.youthShortName">
                      <p>{{ item.organShortName }} - {{ item.youthShortName }}</p>
                    </div>
                    <div class="td changci">
                      <p :title="item.competition+(item.competitionSession ? ' - '+item.competitionSession : '')">{{ item.competition }} <span v-if="item.competitionSession">- {{ item.competitionSession }}</span></p>
                    </div>
                    <div class="td playerName">
                      <p>{{item.playerName}}</p>
                    </div>
                    <div class="td leixing">
                      <p>{{ item.dataType === 'goalkeeper' ? "守门员" : "球员" }}</p>
                    </div>
                    <div class="td choose" >
                      <el-button
                        v-if="item.checked"
                        type="danger"
                        size="small"
                        style="background-color: #f56c6c"
                        icon="el-icon-remove-outline"
                        @click="remove(index)">取消</el-button>
                      <el-button
                        v-else
                    
                        type="primary"
                        size="small"
                        icon="el-icon-circle-plus-outline"
                        @click="add(index)">关联</el-button>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>
          <div>
            <page-small :pageSize="pageSize" :page.sync="page" :total="total"></page-small>
          </div>
          <template v-if="Object.keys(linkObj).length > 0">
            <div style="display: flex;justify-content: center;align-items: center">
              <p>已选择{{Object.keys(linkObj).length}}个</p>
              <el-button
                type="primary"
                size="mini"
                style="margin-left: 15px"
                @click="isShow=false">关闭</el-button>
            </div>
          </template>
        </template>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import storage from '@/utils/storage'
import { ops } from '@/utils/scrollIndialog'
import player from '@/api/player'
import training from '@/api/training'
import teaching from '@/api/teaching'
import tutorial from '@/api/tutorial'
import scout from "@/api/scout";
import person from '@/assets/images/common/person.jpg'
import placeHolderImg from '@/assets/images/common/plan_default.png'
export default {
  name: 'index',
  components: {
    'page-small': () => import('@/components/layout/SmallPage.vue')
  },
  props: {
    type: {
      required: true, // 传入类型
      type: String
    },
    obj: {
      required: false, // 用来判断回显选中的
      type: Object
    },
    organUuid: {
      required: true,
      type: String
    },
    youthUuid: {
      required: true,
      type: String
    },
    showDialog: {
      required: true,
      type: Boolean
    },
    title: {
      required: true,
      type: String
    },
    squardList: {
      type: Array
    }
  },
  data () {
    return {
      placeHolderImg,
      ops,
      checkedAll: false,
      count: 0,
      person,
      uuid: storage.get('userInfo').uuid,
      userRole: storage.get('userInfo').userRole,
      linkList: [ ],
      linkObj: { },
      page: 0,
      pageSize: 20,
      loading: true,
      empty: false,
      total: 0,
      disabled: false,
      squadUuid: ''
    }
  },
  computed: {
    isShow: {
      get () {
        return this.showDialog
      },
      set (val) {
        this.$emit('update:showDialog', val)
      }
    }
  },
  watch: {
    page(val) {
        /* 处理分页 */
       if (this.type === 'player') {
          this.getPlayerList()
        } else if (this.type === 'event') {
          this.getTrainList()
        } else if (this.type === 'plan') {
          this.getPlanList()
        } else if (this.type === 'matchReport') {
          this.getMatchList()
        } else if (this.type === 'scout') {
         this.getScoutList()
       }
    }
  },
  created () {
    if (Object.keys(this.obj).length > 0) {
      this.linkObj = { ...this.linkObj, ...this.obj }
    }
    this.changeQuery(true)
  },
  methods: {
    changeQuery(flag) {
      if(flag) this.page = 0;
      if (this.type === 'player') {
        this.getPlayerList()
      } else if (this.type === 'event') {
        this.getTrainList()
      } else if (this.type === 'plan') {
        this.getPlanList()
      } else if (this.type === 'matchReport') {
        this.getMatchList()
      } else if (this.type === 'scout') {
        this.getScoutList()
      }
    },
    requestPlayer () {
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = player.getPlayerSystem
      } else if (this.userRole === 'organ') {
        request = player.getPlayerOrgan
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = player.getPlayerYouth
      } else if (this.userRole === 'leader' || this.userRole === 'coach') {
        request = player.getPlayerLeaderOrCoach
      } else if (this.userRole === 'player') {
        request = player.getPlayerByPlayer
      }
      request({
        organUuid: this.organUuid,
        youthUuid: this.youthUuid,
        page: this.page,
        size: this.pageSize
      }).then(res => {
        if (res.content.length === 0) {
          this.disabled = true
        } else {
          const list = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.linkList = this.linkList.concat(list)
        }
      }).catch(() => {
        this.disabled = true
      })
    },
    requestTrain () {
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = training.getTrainPlanListSystem
      } else if (this.userRole === 'organ') {
        request = training.getTrainPlanListOrgan
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = training.getTrainPlanListYouth
      } else if (this.userRole === 'leader' || this.userRole === 'coach') {
        request = training.getTrainPlanListCoach
      } else if (this.userRole === 'player') {
        request = training.getTrainPlanListPlayer
      }
      request({ organUuid: this.organUuid, youthUuid: this.youthUuid, page: this.page, size: this.pageSize }).then(res => {
        if (res.content.length === 0) {
          this.disabled = true
        } else {
          const list = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.linkList = this.linkList.concat(list)
        }
      }).catch(() => {
        this.disabled = true
      })
    },
    requestScout () {
      let request
      if (this.userRole === "organ") {
        request = scout.getScoutListByOrg;
      } else if (this.userRole === "system" || this.userRole === "admin") {
        request = scout.getScoutListBySystem;
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = scout.getScoutListByYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        request = scout.getScoutListByTeacher;
      }
      request({ organUuid: this.organUuid, youthUuid: this.youthUuid, page: this.page, size: this.pageSize }).then(res => {
        if (res.content.length === 0) {
          this.disabled = true
        } else {
          const list = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.linkList = this.linkList.concat(list)
        }
      }).catch(() => {
        this.disabled = true
      })
    },
    requestPlan () {
      let request = tutorial.getMyTutorial
      request({ page: this.page, size: this.pageSize }).then(res => {
        if (res.content.length === 0) {
          this.disabled = true
        } else {
          const list = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.linkList = this.linkList.concat(list)
        }
      }).catch(() => {
        this.disabled = true
      })
    },
    requestMatchPlan () {
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = teaching.getMatchTrainListSystem
      } else if (this.userRole === 'organ') {
        request = teaching.getMatchTrainListOrgan
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = teaching.getMatchTrainListYouth
      } else if (this.userRole === 'leader' || this.userRole === 'coach') {
        request = teaching.getMatchTrainListCoach
      } else if (this.userRole === 'player') {
        request = teaching.getMatchTrainListPlayer
      }
      request({ page: this.page, size: this.pageSize }).then(res => {
        if (res.content.length === 0) {
          this.disabled = true
        } else {
          const list = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.linkList = this.linkList.concat(list)
        }
      }).catch(() => {
        this.disabled = true
      })
    },
    load () {
      this.page += 1
      if (this.page > Math.floor(this.total / this.pageSize)) {
        return
      }
      if (this.type === 'player') {
        this.requestPlayer()
      } else if (this.type === 'event') {
        this.requestTrain()
      } else if (this.type === 'plan') {
        this.requestPlan()
      } else if (this.type === 'matchReport') {
        this.requestMatchPlan()
      }else if (this.type === 'scout') {
        this.requestScout()
      }
    },
    getPlayerList () {
      this.loading = true
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = player.getPlayerSystem
      } else if (this.userRole === 'organ') {
        request = player.getPlayerOrgan
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = player.getPlayerYouth
      } else if (this.userRole === 'leader' || this.userRole === 'coach') {
        request = player.getPlayerLeaderOrCoach
      } else if (this.userRole === 'player') {
        request = player.getPlayerByPlayer
      }
      request({
        organUuid: this.organUuid,
        youthUuid: this.youthUuid,
        page: this.page,
        size: this.pageSize,
        squadUuid: this.squadUuid
      }).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
          this.total = res.totalElements
        } else {
          this.empty = false
          this.linkList = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.total = res.totalElements
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getTrainList () {
      this.loading = true
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = training.getTrainPlanListSystem
      } else if (this.userRole === 'organ') {
        request = training.getTrainPlanListOrgan
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = training.getTrainPlanListYouth
      } else if (this.userRole === 'leader' || this.userRole === 'coach') {
        request = training.getTrainPlanListCoach
      } else if (this.userRole === 'player') {
        request = training.getTrainPlanListPlayer
      }
      const submitData = { organUuid: this.organUuid, youthUuid: this.youthUuid, page: this.page, size: this.pageSize, squadUuid: this.squadUuid }
      request(submitData).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
          return
        } else {
          this.empty = false
        }
        this.linkList = res.content.map(item => {
          if (this.linkObj[item.uuid]) {
            item.checked = true
          }
          return item
        })
        this.total = res.totalElements
      }).catch(() => {
        this.loading = false
      })
    },
    getScoutList () {
      this.loading = true
      let request
      if (this.userRole === "organ") {
        request = scout.getScoutListByOrg;
      } else if (this.userRole === "system" || this.userRole === "admin") {
        request = scout.getScoutListBySystem;
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = scout.getScoutListByYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        request = scout.getScoutListByTeacher;
      }
      const submitData = { organUuid: this.organUuid, youthUuid: this.youthUuid, page: this.page, size: this.pageSize, squadUuid: this.squadUuid }
      request(submitData).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
          return
        } else {
          this.empty = false
        }
        this.linkList = res.content.map(item => {
          if (this.linkObj[item.uuid]) {
            item.checked = true
          }
          return item
        })
        this.total = res.totalElements
      }).catch(() => {
        this.loading = false
      })
    },
    getPlanList () {
      this.loading = true
      let request = tutorial.getMyTutorial
      request({ page: this.page, size: this.pageSize }).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
          return
        } else {
          this.empty = false
        }
        this.linkList = res.content.map(item => {
          if (this.linkObj[item.uuid]) {
            item.checked = true
          }
          return item
        })
        this.total = res.totalElements
      }).catch(() => {
        this.loading = false
      })
    },
    getMatchList () {
      this.loading = true
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = teaching.getMatchTrainListSystem
      } else if (this.userRole === 'organ') {
        request = teaching.getMatchTrainListOrgan
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = teaching.getMatchTrainListYouth
      } else if (this.userRole === 'leader' || this.userRole === 'coach') {
        request = teaching.getMatchTrainListCoach
      } else if (this.userRole === 'player') {
        request = teaching.getMatchTrainListPlayer
      }
      request({ organUuid: this.organUuid, youthUuid: this.youthUuid, page: this.page, size: this.pageSize }).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
        } else {
          this.empty = false
          this.linkList = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.total = res.totalElements
        }
      }).catch(() => {
        this.loading = false
      })
    },
    changeBox (val, index) {
      this.$set(this.linkList[index], 'checked', val)
      if (val) {
        this.linkObj[this.linkList[index].uuid] = this.type
        this.$emit('hideDialog', this.linkObj, this.type)
        // 选中某一项时遍历列表假如全部选中就修改全部选中的状态为true
        this.checkedAll = this.linkList.every(item => {
          return item.checked
        })
      } else {
        delete this.linkObj[this.linkList[index].uuid]
        this.$emit('hideDialog', this.linkObj, this.type)
        // 取消选中某一项时修改全部选中的状态为false
        this.checkedAll = false
      }
    },
    changeAllBox (val) {
      if (val) {
        this.linkList.map(item => {
          this.$set(item, 'checked', true)
          // item['checked'] = true
          this.linkObj[item.uuid] = this.type
          return item
        })
      } else {
        this.linkList.map(item => {
          this.$set(item, 'checked', false)
          // item['checked'] = false
          // this.linkObj[item.uuid] = this.type
          return item
        })
        this.linkObj = {}
      }
      this.$emit('hideDialog', this.linkObj, this.type)
    },
    add (index) {
      this.$set(this.linkList[index], 'checked', true)
      this.linkObj[this.linkList[index].uuid] = this.type
      this.$emit('hideDialog', this.linkObj, this.type)
    },
    remove (index) {
      this.$set(this.linkList[index], 'checked', false)
      delete this.linkObj[this.linkList[index].uuid]
      this.$emit('hideDialog', this.linkObj, this.type)
    },
    checkForm () {
      // console.log(this.linkObj)
      this.$emit('hideDialog', this.linkObj, this.type)
    }
  }
}
</script>

<style  lang="stylus">
  @import '~@/assets/css/variable'
  .linkAllDialog
    .el-dialog__body
      padding  15px 20px
    .th
      display flex
      height:40px
      justify-content: center;
      align-items: center;
      border-bottom 1px solid gray
      border-top 1px solid gray
      .tr
        height 100%
        flex  1  1 auto
        border-right 1px solid gray
        display flex
        justify-content center
        align-items center
        p
          text-align center
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: black;
      .choose
        width 15%
      .name
        width 15%
      .img
        width 10%
      .organName
        width 20%
      .youthName
        width 20%
      .idNumber
        width 20%
      .opt
        width 15%
      .danwei
        width 20%
      .changci
        width 25%
      .playerName
        width 10%
      .leixing
        width 10%
    .tbody
      display: flex
      justify-content center
      align-items center
      border-bottom 1px solid gray
      height 49px
      .td
        border-right 1px solid gray
        height 100%
        flex  1  1 auto
        display flex
        justify-content center
        align-items center
        p
          text-align center
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: black;
      .choose
        width 15%
      .name
        width 15%
      .img
        width 10%
      .organName
        width 20%
      .youthName
        width 20%
      .idNumber
        width 20%
      .opt
        width 15%
    .tbody1
      display: flex
      justify-content center
      align-items center
      border-bottom 1px solid gray
      height 49px
      .td
        border-right 1px solid gray
        height 100%
        flex  1  1 auto
        display flex
        justify-content center
        align-items center
        p
          text-align center
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: black;
      .choose
        width 15%
      .danwei
        width 148px
      .changci
        width 185px
      .playerName
        width 10%
      .leixing
        width 10%
    .el-pagination
      color black
      .el-pagination__total,.el-pagination__jump
        color black
      .btn-prev,.btn-next
        color black
      ul > li
        color black
      ul > li:hover
        color $green_color
      ul > li.active
        color  $green_color
  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: $green_color;
    border-color: $green_color;
  }
</style>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
    .tutorial
      color #999
      font-size 16px
      .item
        padding 10px 0
        border-bottom 1px solid #CCC
        margin 0 20px
        .title
          padding 10px 0 25px 0
          font-size 20px
          font-weight bold
          color #000
        .info_content
          display flex
          img
            width 207px
            height 121px
            margin-right 25px
          .info
            display flex
            flex-direction column
            justify-content center
            flex 1
            p
              margin-bottom 10px
          .btn_wrap
            margin-right 40px
            .btn
              margin-top 10px
              text-align center
</style>
